import { render, staticRenderFns } from "./DisasterFilter.vue?vue&type=template&id=36a09712"
import script from "./DisasterFilter.vue?vue&type=script&lang=ts"
export * from "./DisasterFilter.vue?vue&type=script&lang=ts"
import style0 from "./DisasterFilter.vue?vue&type=style&index=0&id=36a09712&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports